import { render, staticRenderFns } from "./PromoDialog.vue?vue&type=template&id=1091c9ec&scoped=true&"
import script from "./PromoDialog.vue?vue&type=script&lang=js&"
export * from "./PromoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1091c9ec",
  null
  
)

export default component.exports